module.exports = __webpack_public_path__ + "media/images/piggy-bank-a6d5d7e5.png";